import React from "react";
import { Busy } from "../presentational/busy";
import { SelectedCharities } from "../presentational/selectedCharities";
import { Card } from "../presentational/card";
import { CategoryNavigation } from "../presentational/categoryNavigation";
import { SuggestedCharity } from "../presentational/suggestedCharity";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import ReactGA from "react-ga";
import styles from "../../styles/panels/nationalCharitySelector.css";
import * as utilities from "../../middleware/utilities";

export class NationalCharitySelector extends React.Component {
  constructor(props) {
    super(props);
    this.onScroll = this.onScroll.bind(this);
    this.state = {
      busy: false,
      nationalCharities: [],
      charity: null,
      hoverPosition: { top: 0, left: 0 },
      searchCount: null,
      searched: false,
      filter: {
        query: "",
        postalCode: "",
        columnName: "",
        continuationToken: null,
      },
      collapse: false,
    };
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/NationalCharitySelector");
    window.addEventListener("scroll", this.onScroll);
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    if (
      document.documentElement.offsetHeight ==
        document.documentElement.scrollTop + window.innerHeight &&
      !this.state.busy &&
      this.state.searchCount > this.state.nationalCharities.length
    ) {
      this.getMoreCharities();
    }
  }

  getCharities() {
    ReactGA.event({
      category: "User Action",
      action: "Search",
      label:
        "Query: " +
        this.state.filter.query +
        "Postal Code: " +
        this.state.filter.postalCode +
        "Category: " +
        this.state.filter.columnName,
    });
    this.setState({ busy: true }, () => {
      utilities
        .getNationalCharities({
          ...this.state.filter,
          continuationToken: null,
        })
        .then((nationalCharities) => {
          this.setState({
            busy: false,
            nationalCharities: nationalCharities.charities,
            searchCount: nationalCharities.totalCount,
            searched: true,
            filter: {
              ...this.state.filter,
              continuationToken: nationalCharities.continuationToken,
            },
            collapse: true,
          });
        });
    });
  }
  getMoreCharities() {
    ReactGA.event({
      category: "User Action",
      action: "Search More",
      label:
        "Query: " +
        this.state.filter.query +
        "Postal Code: " +
        this.state.filter.postalCode +
        "Category: " +
        this.state.filter.columnName,
    });
    this.setState({ busy: true }, () => {
      utilities
        .getNationalCharities(this.state.filter)
        .then((nationalCharities) => {
          console.log(nationalCharities);
          this.setState({
            busy: false,
            nationalCharities: this.state.nationalCharities.concat(
              nationalCharities.charities
            ),
            searchCount: nationalCharities.totalCount,
            filter: {
              ...this.state.filter,
              continuationToken: nationalCharities.continuationToken,
            },
          });
        });
    });
  }
  renderBusy() {
    return (
      <div className={styles.charities}>
        <div className={styles.busy}>
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          {this.state.nationalCharities.length > 0 ? (
            <div
              className={styles.icon}
              onClick={() => {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Back Button",
                  label: "/Spend/NationalCharitySelector",
                });
                this.setState({ nationalCharities: [] });
                // this.props.onBack();
              }}
            >
              <FontAwesomeIcon icon={faArrowCircleLeft} />
            </div>
          ) : null}
          {this.props.dictionary.national_charity_selector_header}
        </div>
      </div>
    );
  }
  renderSearch() {
    return (
      <div className={styles.search}>
        <div className={styles.query}>
          <label>
            {this.props.dictionary.national_charity_selector_query_label}
          </label>
          <input
            type="text"
            value={this.state.filter.query}
            onChange={(event) => {
              this.setState({
                filter: {
                  ...this.state.filter,
                  query: event.currentTarget.value,
                },
              });
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                this.getCharities();
              }
            }}
          />
          <button
            className={
              styles.button +
              (this.state.filter.query.length > 0 ? " " + styles.active : "")
            }
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Search",
                label: "/Spend/NationalCharitySelector",
              });
              this.getCharities();
            }}
          >
            {this.props.dictionary.national_charity_selector_search}
          </button>
        </div>
        <div
          className={
            styles.filter +
            (this.state.searchCount > 0 && this.state.collapse
              ? " " + styles.mobileHide
              : "")
          }
        >
          <div className={styles.postal}>
            <label>
              {this.props.dictionary.national_charity_selector_postal_label}
            </label>
            <input
              type="text"
              value={this.state.filter.postalCode}
              maxLength="5"
              onChange={(event) => {
                this.setState({
                  filter: {
                    ...this.state.filter,
                    postalCode: event.currentTarget.value,
                  },
                });
              }}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  this.getCharities();
                }
              }}
            />
          </div>
          <div className={styles.category}>
            <label>
              {this.props.dictionary.national_charity_selector_category_label}
            </label>
            <select
              value={this.state.filter.columnName}
              onChange={(event) => {
                this.setState({
                  filter: {
                    ...this.state.filter,
                    columnName: event.currentTarget.value,
                  },
                });
              }}
            >
              <option value="">Select category</option>
              {this.props.categories.map((category) => {
                return (
                  <option key={category.id} value={category.columnName}>
                    {category.title}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className={styles.resultCount}>
          {this.state.searchCount > 0
            ? `${this.state.searchCount} ${this.props.dictionary.national_charity_selector_results_label}`
            : this.state.searched
            ? "No search results"
            : null}
          {this.state.searched && (
            <div
              className={styles.collapse}
              onClick={() => {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Collapse Button " + !this.state.collapse,
                  label: "/Spend/NationalCharitySelector",
                });
                this.setState({ collapse: !this.state.collapse });
              }}
            >
              <FontAwesomeIcon
                className={styles.icon}
                icon={this.state.collapse ? faChevronDown : faChevronUp}
              />
              {this.state.collapse
                ? this.props.dictionary.national_charity_selector_open_filter
                : this.props.dictionary.national_charity_selector_close_filter}
            </div>
          )}
        </div>
      </div>
    );
  }
  renderCallout() {
    return (
      <div className={styles.callout}>
        <div
          className={styles.slide}
          style={{
            top: this.state.hoverPosition.top,
            left: this.state.hoverPosition.left,
          }}
        >
          <div className={styles.beak} />
          <div className={styles.details}>
            <h2>{this.state.charity.name}</h2>
            <div>{this.state.charity.description}</div>
          </div>
        </div>
      </div>
    );
  }
  renderFeaturedCharity(charity, selectedEINs) {
    return (
      <div
        className={styles.featuredCharity}
        key={charity.ein}
        onClick={() => {
          ReactGA.event({
            category: "User Action",
            action: "Clicked Open Charity " + charity.ein,
            label: "/Spend/NationalCharitySelector",
          });
          this.props.onViewCharity(charity);
        }}
      >
        <div className={styles.imageSpace}>
          <img
            src={charity.image}
            title={charity.title}
            className={styles.image}
            onMouseEnter={(event) => {
              let boundingClientRect = event.target.getBoundingClientRect();
              this.setState({
                charity: charity,
                hoverPosition: {
                  top: boundingClientRect.top,
                  left: boundingClientRect.left + event.target.width,
                },
              });
            }}
            onMouseLeave={() => {
              this.setState({
                charity: null,
                hoverPosition: { top: 0, left: 0 },
              });
            }}
          />
        </div>
        <div className={styles.label}>{charity.name}</div>
        <div className={styles.commands}>
          {selectedEINs.indexOf(charity.ein) == -1 ? (
            this.props.additionalCharityCount >=
            this.props.selectedCharities.length ? (
              <button
                className={styles.button + " " + styles.select}
                onClick={(event) => {
                  event.stopPropagation();
                  ReactGA.event({
                    category: "User Action",
                    action: "Clicked Select Charity",
                    label: "/Spend/NationalCharitySelector",
                  });
                  this.props.onSelectCharity(charity);
                }}
              >
                {this.props.dictionary.national_charity_selector_select}
              </button>
            ) : (
              <button className={styles.button + " " + styles.disabled}>
                {this.props.dictionary.national_charity_selector_disabled}
              </button>
            )
          ) : (
            <button
              className={styles.button + " " + styles.unselect}
              onClick={(event) => {
                event.stopPropagation();
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Remove Charity",
                  label: "/Spend/NationalCharitySelector",
                });
                this.props.onRemoveCharity(charity.ein);
              }}
            >
              {this.props.dictionary.national_charity_selector_unselect}
            </button>
          )}
        </div>
      </div>
    );
  }
  renderNationalCharity(charity, selectedEINs) {
    return (
      <div className={styles.nationalCharity} key={charity.ein}>
        <div className={styles.summary}>
          <div className={styles.label}>{charity.name}</div>
          <div className={styles.description}>{charity.description}</div>
          <div className={styles.ein}>EIN:&nbsp;{charity.ein}</div>
          <div className={styles.address}>
            <div className={styles.street}>{charity.street}</div>
            <div className={styles.city}>{charity.city},</div>
            <div className={styles.state}>{charity.state}</div>
            <div className={styles.postalCode}>{charity.postalCode}</div>
          </div>
        </div>
        <div className={styles.commands}>
          {selectedEINs.indexOf(charity.ein) == -1 ? (
            this.props.additionalCharityCount >=
            this.props.selectedCharities.length ? (
              <button
                className={styles.button + " " + styles.select}
                onClick={(event) => {
                  event.stopPropagation();
                  ReactGA.event({
                    category: "User Action",
                    action: "Clicked Select Charity",
                    label: "/Spend/NationalCharitySelector",
                  });
                  this.props.onSelectCharity(charity);
                }}
              >
                {this.props.dictionary.national_charity_selector_select}
              </button>
            ) : (
              <button className={styles.button + " " + styles.disabled}>
                {this.props.dictionary.national_charity_selector_disabled}
              </button>
            )
          ) : (
            <button
              className={styles.button + " " + styles.unselect}
              onClick={(event) => {
                event.stopPropagation();
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Remove Charity",
                  label: "/Spend/NationalCharitySelector",
                });
                this.props.onRemoveCharity(charity.ein);
              }}
            >
              {this.props.dictionary.national_charity_selector_unselect}
            </button>
          )}
        </div>
      </div>
    );
  }
  renderCharities() {
    let selectedEINs = this.props.selectedCharities.map((charity) => {
      return charity.ein;
    });
    return (
      <div
        className={
          styles.charities + (this.state.collapse ? " " + styles.small : "")
        }
      >
        {this.state.nationalCharities.map((charity) => {
          if (charity.partitionKey == "0") {
            return this.renderFeaturedCharity(charity, selectedEINs);
          } else {
            return this.renderNationalCharity(charity, selectedEINs);
          }
        })}
        {this.state.charity ? this.renderCallout() : null}
        {this.state.busy ? this.renderBusy() : null}
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <SelectedCharities
          selectedCharities={this.props.selectedCharities}
          dictionary={this.props.dictionary}
          additionalCharityCount={this.props.additionalCharityCount}
          collapse={this.props.collapseSelectedCharities}
          donation={this.props.donation}
          onToggleCollapse={() => {
            this.props.onToggleCollapseSelectedCharities();
          }}
          onRemoveCharity={(ein) => {
            this.props.onRemoveCharity(ein);
          }}
          onContinue={() => {
            this.props.onContinue();
          }}
        />
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
        {this.props.donation.campaignDetail &&
        this.props.donation.campaignDetail.suggestedCharity &&
        this.props.donation.campaignDetail.suggestedCharityMarkup ? (
          <div className={styles.mobileHide}>
            <SuggestedCharity
              fixedPosition={true}
              charity={this.props.donation.campaignDetail.suggestedCharity}
              markup={this.props.donation.campaignDetail.suggestedCharityMarkup}
              selectedCharities={this.props.selectedCharities}
              dictionary={this.props.dictionary}
              additionalCharityCount={this.props.additionalCharityCount}
              onViewCharity={(charity) => {
                this.props.onViewCharity(charity);
              }}
              onSelectCharity={(charity) => {
                this.props.onSelectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.props.onRemoveCharity(ein);
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }

  renderCategories() {
    return (
      <div className={styles.categories}>
        {this.props.categories.map((category) => {
          return (
            <div
              className={styles.category}
              key={category.id}
              onClick={() => {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Category " + category.title,
                  label: "/Spend/CategorySelector",
                });
                this.props.onSelectCategory(category);
              }}
            >
              <img
                src={category.thumbnail}
                title={category.title}
                className={styles.image}
              />
              <div className={styles.label}>{category.title}</div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div className={styles.content}>
            {this.renderSearch()}
            {this.renderCharities()}
            {!this.state.busy && this.state.nationalCharities.length == 0
              ? this.renderCategories()
              : null}
            {/* {this.state.nationalCharities.length == 0 ? (
              <CategoryNavigation
                dictionary={this.props.dictionary}
                categories={this.props.categories}
                selectedCategory={this.props.selectedCategory}
                onSelectCategory={(category) => {
                  this.props.onSelectCategory(category);
                }}
                onSearchAll={() => {
                  this.props.onSearchAll();
                }}
              />
            ) : null} */}
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
